import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  dashboard2MetadataTextSx,
  dashboard2SectionDescriptionSx,
  dashboard2WeekPlanIntroSx,
  dashboard2WeekPlanProgressBarSx,
  dashboard2WeekPlanProgressMetaSx,
  dashboard2WeekPlanTitleSx
} from "../dashboard2-status.styles";

type Dashboard2WeekPlanIntroProps = {
  planned: number;
  total: number;
};

export const Dashboard2WeekPlanIntro: React.FC<Dashboard2WeekPlanIntroProps> = ({
  planned,
  total
}) => {
  const { t } = useTranslation();
  const progressValue = total > 0 ? Math.round((planned / total) * 100) : 0;
  const progressLabel = t("_dashboard2_planWeekProgress", { planned, total });

  return (
    <Box sx={dashboard2WeekPlanIntroSx} data-testid="dashboard2-week-plan-intro">
      <Typography component="h2" variant="inherit" sx={dashboard2WeekPlanTitleSx}>
        {t("_dashboard2_planWeekTitle")}
      </Typography>

      <Box sx={dashboard2WeekPlanProgressMetaSx}>
        <Typography
          variant="inherit"
          sx={{ ...(dashboard2SectionDescriptionSx as object), minWidth: 0 }}
        >
          {t("_dashboard2_planWeekDescription")}
        </Typography>
        <Typography
          variant="inherit"
          sx={{ ...(dashboard2MetadataTextSx as object), flexShrink: 0 }}
          aria-hidden
        >
          {progressLabel}
        </Typography>
      </Box>

      <LinearProgress
        variant="determinate"
        value={progressValue}
        sx={dashboard2WeekPlanProgressBarSx}
        aria-label={progressLabel}
        data-testid="dashboard2-week-plan-progress"
      />
    </Box>
  );
};
